// extracted by mini-css-extract-plugin
export var grid = "_2j-0";
export var span1 = "_2j-2";
export var span10 = "_2j-b";
export var span10L = "_2j-z";
export var span10M = "_2j-n";
export var span10Xl = "_2j-1b";
export var span11 = "_2j-c";
export var span11L = "_2j-10";
export var span11M = "_2j-o";
export var span11Xl = "_2j-1c";
export var span12 = "_2j-d";
export var span12L = "_2j-11";
export var span12M = "_2j-p";
export var span12Xl = "_2j-1d";
export var span1L = "_2j-q";
export var span1M = "_2j-e";
export var span1Xl = "_2j-12";
export var span2 = "_2j-3";
export var span2L = "_2j-r";
export var span2M = "_2j-f";
export var span2Xl = "_2j-13";
export var span3 = "_2j-4";
export var span3L = "_2j-s";
export var span3M = "_2j-g";
export var span3Xl = "_2j-14";
export var span4 = "_2j-5";
export var span4L = "_2j-t";
export var span4M = "_2j-h";
export var span4Xl = "_2j-15";
export var span5 = "_2j-6";
export var span5L = "_2j-u";
export var span5M = "_2j-i";
export var span5Xl = "_2j-16";
export var span6 = "_2j-7";
export var span6L = "_2j-v";
export var span6M = "_2j-j";
export var span6Xl = "_2j-17";
export var span7 = "_2j-8";
export var span7L = "_2j-w";
export var span7M = "_2j-k";
export var span7Xl = "_2j-18";
export var span8 = "_2j-9";
export var span8L = "_2j-x";
export var span8M = "_2j-l";
export var span8Xl = "_2j-19";
export var span9 = "_2j-a";
export var span9L = "_2j-y";
export var span9M = "_2j-m";
export var span9Xl = "_2j-1a";
export var stretch = "_2j-1";